import Box from "@mui/material/Box";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { RecordingInfoViewModel } from "../../ViewModels/RecordingViewModel";
import SecondaryCallTabs from "../SecondaryCallTabs";
import PrimaryCallTabs from "../PrimaryCallTabs";
import CallTabPages from "../CallTabPages";
import TranscriptSearch from "../Transcripts/TranscriptSearch";
import { APIContext } from "src/components/Contexts/APIContext"
import { CallInfoTabsHaveValues } from "../ViewModels/CallInfoTabsHaveValues";

const styles = {
    tab: {
        padding: '0',
        height: '100%'
    },
    fullHeight: {
        height: '100%'
    },
    borderBox: {
        borderLeft: 'solid 1px black',
        borderRight: 'solid 1px black'
    }
};

interface IMonitoringCallInfoContainer {
    id: string | null;
    setId: (newId: string) => void;
    setCallRefId?: (callRefId: string) => void;
    setRescoreCompleteId?: (completeId: number) => void;
    setSelectedCallIndex: (index: number) => void;
    recordings: RecordingInfoViewModel;
    close?: () => void;
    completeId?: number;
    agentView?: boolean;
    feedbackView?: string;
    transcriptSearch?: TranscriptSearch;
    agentHasResponded?: boolean;
    mainView?: boolean;
    isUsersCall?: boolean;
}

export default function MonitoringCallInfoContainer(props: IMonitoringCallInfoContainer) {
    const { isClient, isTeamLeader, get } = useContext(APIContext);

    const [primaryTabIndex, setPrimaryTabIndex] = useState<number>(0);
    const [secondaryTabIndex, setSecondaryTabIndex] = useState<number>(0);
    const [timerActive, setTimerActive] = useState<boolean>(false);
    const [isClientScorecardEnabled, setIsClientScorecardEnabled] = useState(false);
    const [isOperationsScorecardEnabled, setIsOperationsScorecardEnabled] = useState(false);
    const [roleCanSeeScorecard, setRoleCanSeeScorecard] = useState<boolean>(false);
    const [tabEnabled, setTabEnabled] = useState<CallInfoTabsHaveValues | null>(null);

    useEffect(() => {
        if (isTeamLeader) {
            get('User', `IsOperationsScorecardEnabled?client=${props.recordings.client}`, (result: boolean) => {
                setIsOperationsScorecardEnabled(result);
            });
        }
        if (isClient) {
            get('User', 'IsClientScorecardEnabled', (result: boolean) => {
                setIsClientScorecardEnabled(result);
            });
        }
    }, [isClient, isTeamLeader]);

    useEffect(() => {
        if (isTeamLeader) {
            if (isOperationsScorecardEnabled) {
                setRoleCanSeeScorecard(true);
            }
            else {
                setRoleCanSeeScorecard(false);
            }
        }
        else if (isClient) {
            if (isClientScorecardEnabled) {
                setRoleCanSeeScorecard(true);
            }
            else {
                setRoleCanSeeScorecard(false);
            }
        }
        else {
            setRoleCanSeeScorecard(true);
        }
    }, [isTeamLeader, isClient, isClientScorecardEnabled, isOperationsScorecardEnabled]);

    const handlePrimaryCallIndexChange = (index: number) => {
        setPrimaryTabIndex(index);
        props.setSelectedCallIndex(index);
    }

    const toggleTimerActive = (active: boolean) => {
        setTimerActive(active);
    }

    return (
        props.id !== null && props.recordings ?
            <Box display="flex" flexDirection="column" sx={styles.fullHeight} overflow='hidden'>
                {
                    props.recordings.recordings.length <= 1 ?
                        <div style={{ borderTop: 'solid 1px black' }} />
                        :
                        <PrimaryCallTabs
                            index={primaryTabIndex}
                            setIndex={handlePrimaryCallIndexChange}
                            calls={props.recordings} />
                }
                <SecondaryCallTabs
                    index={secondaryTabIndex}
                    setIndex={setSecondaryTabIndex}
                    feedbackView={props.feedbackView}
                    agentView={props.agentView}
                    mainView={props.mainView}
                    timerActive={timerActive}
                    roleCanSeeScorecard={roleCanSeeScorecard}
                    callInfoTabsEnabled={tabEnabled}
                />
                <Box flexGrow={1} overflow="auto" sx={styles.borderBox}>
                    <CallTabPages
                        id={props.id}
                        setId={props.setId}
                        switchCallId={props.recordings.recordings.length === 0 ? undefined : props.recordings.recordings[primaryTabIndex].switchCallID}
                        index={secondaryTabIndex}
                        agentView={props.agentView}
                        feedbackView={props.feedbackView}
                        completeId={props.completeId}
                        setRescoreCompleteId={props.setRescoreCompleteId}
                        close={props.close}
                        transcriptSearch={props.transcriptSearch}
                        agentHasResponded={props.agentHasResponded}
                        systemId={props.recordings.systemId}
                        mainView={props.mainView}
                        isUsersCall={props.isUsersCall}
                        toggleTimerActive={toggleTimerActive}
                        roleCanSeeScorecard={roleCanSeeScorecard}
                        setCallInfoTabsHaveValues={setTabEnabled}
                    />
                </Box>
            </Box>
            :
            <Fragment />
    );
}